import { createAction } from 'redux-actions';
import { PageDataLayout } from '../../types/papi';

export const fetchPageLayoutSuccess = createAction(
  'PAGE.LAYOUT.FETCH.SUCCESS',
  (payload: PageDataLayout) => payload
);
